import styled from 'styled-components';

export const UnderlinedSpan = styled.span`
  text-decoration: underline;
`;
